import { render, staticRenderFns } from "./orderDurationDailyChartWidget.vue?vue&type=template&id=bbe1ffb4&"
import script from "./orderDurationDailyChartWidget.vue?vue&type=script&lang=js&"
export * from "./orderDurationDailyChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports